module.exports = __webpack_public_path__ + "img/SWP_Axe_1H_02 (2).2b9cdb51.png";